import styled from 'styled-components'

export const AccordionContainer = styled.div<{ $userType?: string | null }>`
  width: 100%;
  margin: 0;
  overflow: hidden;
  gap: ${({ $userType }) => ($userType === 'student' ? '0' : '15px')};
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`

export const AccordionItem = styled.div`
  &:last-child {
    border-bottom: none;
  }
`

export const AccordionHeader = styled.button<{
  $userType?: string | null
  $isOpen: boolean
}>`
  width: 100%;
  padding: 15px 35px 15px 20px;
  border-radius: 10px;
  outline: none;
  font-size: 16px;
  font-weight: bold;
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  border: 0.5px solid #08a8d2;
  font-size: 18px;
  background-color: ${({ $isOpen }) => ($isOpen ? '#08aad252' : '#ffffff')};

  svg {
    font-size: 25px;
  }
`

export const AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? '100%' : '0')};
  overflow: hidden;
  text-align: left;
  padding: ${({ $isOpen }) => ($isOpen ? '15px' : '0 15px')};
  gap: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding: ${({ $isOpen }) => ($isOpen ? '15px 0px' : '0 15px')};
  }
`

export const AccordionSidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  width: 400px;
  border-right: 1px solid #ddd;
`

export const AccordionContentSide = styled.div<{ $isOpen: boolean }>`
  width: ${({ $isOpen }) => ($isOpen ? '400px' : '0')};
  overflow: hidden;
  text-align: left;
  padding: ${({ $isOpen }) => ($isOpen ? '15px' : '0 15px')};
  gap: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-box-shadow: 0px 0px 37px -16px rgba(145, 145, 145, 1);
  -moz-box-shadow: 0px 0px 37px -16px rgba(145, 145, 145, 1);
  box-shadow: 0px 0px 37px -16px rgba(145, 145, 145, 1);
  margin: 40px;
  border-radius: 20px;
  background-color: #ffffff;

  @media screen and (max-width: 768px) {
    padding: ${({ $isOpen }) => ($isOpen ? '15px 0px' : '0 15px')};
  }
`
